module.exports = __webpack_public_path__ + "img/explainer-12.fca20fc0.jpg";